<template>
  <div class="container-fluid px-md-4">
    <h3>Redirecting to Login</h3>
    <div class="loader m-auto"></div>
  </div>
</template>

<script>
export default {
  mounted: function () {
    this.$nextTick(function () {
      debugger;
      this.$router.push({ name: "home" });
      // Code that will run only after the // entire view has been rendered }) }
    });
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>